import { useTranslation } from 'react-i18next';
import type { NotificationProviderStatus } from '@/api/notificationProviders/notificationProvidersApi.types';
import { Badge } from '@/components/ui/badge';

interface ProviderStatusBadgeProps {
  status: NotificationProviderStatus | undefined;
}

export function ProviderStatusBadge({ status }: ProviderStatusBadgeProps) {
  const { t } = useTranslation('notifications');
  const usesPlatformDefault = status === undefined || status.usesPlatformDefault === true;
  if (usesPlatformDefault) {
    return (
      <Badge tone="muted" size="sm" uppercase>
        {t('providers.platformDefault')}
      </Badge>
    );
  }
  if (status.isConfigured === false) {
    return (
      <Badge tone="muted" size="sm" uppercase>
        {t('providers.notSetUp')}
      </Badge>
    );
  }
  return (
    <Badge tone="success" size="sm" uppercase>
      {t('providers.configured')}
    </Badge>
  );
}
